import React, { FC } from 'react'
import classnames from 'classnames'

import InStoreStockLabel from './InStoreStockLabel'
import PickUpStockLabel from './PickUpStockLabel'
import DeliveryStockLabel from './DeliveryStockLabel'
import SkuSimulationErrorLabel from './SkuSimulationErrorLabel'

interface ProductAvailabilityInfoProps {
  isLoadingInStoreStock: boolean
  isLoadingSimulationStock: boolean
  inStoreQuantity: number
  hasDeliveryStock: boolean
  hasPickUpStock: boolean
  hasSimulationError: boolean
  handleRefresh: () => (skuId: string) => void
  type?: 'column' | 'row'
}

const ProductAvailabilityInfo: FC<ProductAvailabilityInfoProps> = ({
  isLoadingInStoreStock,
  isLoadingSimulationStock,
  inStoreQuantity,
  hasDeliveryStock,
  hasPickUpStock,
  hasSimulationError,
  handleRefresh,
  type = 'column',
}) => {
  const isColumn = type === 'column'
  const stockId =
    isLoadingInStoreStock || isLoadingSimulationStock
      ? 'stockloading'
      : 'stockdone'

  const availabilityClass = classnames('flex tl c-on-base pv3 ph3', {
    'flex-column justify-between': isColumn,
    'flex-row-ns flex-column-ml justify-around-ns justify-between-ml': !isColumn,
  })

  const stockClasses = classnames({
    'mb3-ns mb4-s flex': isColumn,
    'mb0-ns mb3-s flex  ': !isColumn,
  })

  const slasStocksClasses = classnames('flex', {
    'flex-column justify-between': isColumn,
    'flex-row-ns flex-column-ml justify-around-ns justify-between-ml w-two-thirds-ns ': !isColumn,
  })

  const renderStockChannels = () => {
    if (hasSimulationError && !isLoadingSimulationStock) {
      return (
        <div>
          <SkuSimulationErrorLabel handleRefresh={handleRefresh} />
        </div>
      )
    }
    return (
      <div className={slasStocksClasses}>
        <div className={stockClasses}>
          <DeliveryStockLabel
            hasDelivery={hasDeliveryStock}
            loading={isLoadingSimulationStock}
          />
        </div>
        <div className="flex">
          <PickUpStockLabel
            hasPickUp={hasPickUpStock}
            loading={isLoadingSimulationStock}
          />
        </div>
      </div>
    )
  }

  return (
    <div id={stockId} data-testid={stockId} className={availabilityClass}>
      <div className={stockClasses}>
        <InStoreStockLabel
          quantity={inStoreQuantity}
          loading={isLoadingInStoreStock}
        />
      </div>
      {renderStockChannels()}
    </div>
  )
}

export default ProductAvailabilityInfo
